import { Fragment } from 'react';
import { Link } from 'react-router-dom';

const FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/how-to-play', label: 'How to Play' },
  { to: '/news', label: 'News' },
  { to: '/archive', label: 'Archive' },
  { to: '/privacy-policy', label: 'Privacy' },
  { to: '/about#contact', label: 'Contact' },
] as const;

export function SiteFooter() {
  return (
    <footer className="shrink-0 pb-1 pt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
      {FOOTER_LINKS.map((item, i) => (
        <Fragment key={`${item.to}-${item.label}`}>
          {i > 0 && (
            <span className="text-foreground/20" aria-hidden>
              ·
            </span>
          )}
          <Link
            to={item.to}
            className="text-xs text-foreground/35 hover:text-foreground/60 transition-colors"
          >
            {item.label}
          </Link>
        </Fragment>
      ))}
    </footer>
  );
}
